export enum DailyValueCalculationMethod {
  Rounded = 0,
  Unrounded = 1,
}